import * as React from 'react';
import {
  CalendarItem as CalendarItemProps,
} from '../../core/typings/api';
import './styles.scss';

const CalendarItem = ({
  colourCode,
  country,
  dates,
  detailsLink,
  raceHubLink,
  name,
  venue,
  continentCode,
  isUciEvent,
}: CalendarItemProps) => (
  <div className={`
    calendar-item calendar-item--${colourCode}
    ${raceHubLink && 'calendar-item--has-racehub-link'}
    ${isUciEvent && 'calendar-item--is-uci-event'}
  `}
  >
    <div className="calendar-item__title">
      <a href={detailsLink.url} title={detailsLink.title}>
        {name}
      </a>
    </div>
    <div className="calendar-item__location">
      {venue && (
        <span>
          {venue}
          &nbsp;
          |
          &nbsp;
        </span>
      )}
      {country}
      {continentCode && (
        <span>
          &nbsp;
          |
          &nbsp;
          {continentCode}
          &nbsp;
        </span>
      )}
    </div>
    <div className="calendar-item__dates">
      {dates}
    </div>
    {raceHubLink && (
      <div className="calendar-item__race-hub-link">
        <a href={raceHubLink.url} title={raceHubLink.title}>
          {raceHubLink.title}
        </a>
      </div>
    )}
  </div>
);

export default CalendarItem;
